import { connect } from 'react-redux';
import { List, Map } from 'immutable';

import decorate from '../../../../utils/decorate';

import { request as getMarketTemplatesList } from '../../../../modules/market-templates/actions/get-list';

import { TwoParticipantsSportsTab } from './TwoParticipantsSportsTab';

function mapStateToProps(state, props) {
    return {
        marketTemplates: state.marketTemplates.get('items', Map())
            .filter(t => t.getIn([ 'sport', 'id' ]) === props.sport)
            .sortBy(t => t.get('displayOrder'))
            .slice(0, 4).toJS(),
        sportId: props.sport,
    };
}

function mapDispatchToProps(dispatch, props) {

    return {
        onGetMarketTemplatesList: () => {
            const sportId = props.sport;
            return dispatch(getMarketTemplatesList(sportId, { cache: true }));
        },
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    TwoParticipantsSportsTab
);
